import { inject } from '@angular/core';

import { CustomAlertsService } from './custom-alerts.service';
import { ResolveFn } from '@angular/router';

export const customAlertsResolver: ResolveFn<void> = async () => {
  const customAlertService = inject(CustomAlertsService);

  return customAlertService.getAllCustomBanners();
}
